import { DAYS_OF_MONTH } from './consts';

export const getMonthlyBudget = dailyBudget => Math.floor(DAYS_OF_MONTH * dailyBudget);
